import { render } from "./UsuariosView.vue?vue&type=template&id=c05c5192&ts=true"
import script from "./UsuariosView.vue?vue&type=script&lang=ts"
export * from "./UsuariosView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__